import { useState, useEffect, useCallback } from "react";

function useModalWithHistory(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);

  const handleOpen = useCallback((open) => {
    if (open) window.history.pushState(null, "");
    else window.history.replaceState(null, "");
    setIsOpen(open);
  }, []);

  useEffect(() => {
    const handlePopState = () => setIsOpen(false);

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return [isOpen, handleOpen];
}

export default useModalWithHistory;
